import {createFeatureSelector, createSelector} from '@ngrx/store';
import {State} from './clips.load-by-id.reducer';
import {Clip} from '../../../services/api/clips/clip.model';

export const loadClipByIDFeatureKey = 'clip';
export const featureSelector = createFeatureSelector<State>(loadClipByIDFeatureKey);

export const getClipByIDRecord = createSelector(
  featureSelector,
  (state: State): Clip => state.record
);

export const getClipByIDLoaded = createSelector(
  featureSelector,
  (state: State): boolean => state.loaded
);

export const getClipByIDLoading = createSelector(
  featureSelector,
  (state: State): boolean => state.loading
);

export const getClipByIDError = createSelector(
  featureSelector,
  (state: State): any => state.error
);
